import type { ReactNode } from 'react';
import { HomeIcon, PeopleIcon, PersonIcon, TreasureIcon } from './Icons';

export type MainTab = 'rooms' | 'together' | 'treasures' | 'me';

type Props = { active: MainTab; onChange: (tab: MainTab) => void };

function NavButton({active,onClick,icon,label}:{active:boolean;onClick:()=>void;icon:ReactNode;label:string}) {
  return <button type="button" className={active ? 'active' : ''} aria-current={active ? 'page' : undefined} onClick={onClick}>{icon}<span>{label}</span></button>;
}

export function BottomNav({active,onChange}: Props) {
  return <nav className="bottom-nav" aria-label="Hauptnavigation">
    <NavButton active={active === 'rooms'} onClick={() => onChange('rooms')} icon={<HomeIcon/>} label="Räume"/>
    <NavButton active={active === 'together'} onClick={() => onChange('together')} icon={<PeopleIcon/>} label="Miteinander"/>
    <NavButton active={active === 'treasures'} onClick={() => onChange('treasures')} icon={<TreasureIcon/>} label="Schätze"/>
    <NavButton active={active === 'me'} onClick={() => onChange('me')} icon={<PersonIcon/>} label="Mein Raum"/>
  </nav>;
}
